// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__3wP_0","header":"MessagesList_header__3J3Uh","chat":"MessagesList_chat__JbLUW"};